import styled from '@emotion/styled'

export const CopyButtons = styled.div`
  display: flex;
  margin-right: -10px !important;
  gap: 0.5em;
`
